import { css, cx } from '@linaria/core';
import { baseUnits, flex } from 'styles/utils';
export const helpTooltipWrapper = cx("omponents__Formik__LabelWithTooltip__LabelWithTooltip_styles_ts-helpTooltipWrapper-hxs5g25", flex.init, flex.alignItems.start);
export const iconHelp = "omponents__Formik__LabelWithTooltip__LabelWithTooltip_styles_ts-iconHelp-iohiz7p";

require("./LabelWithTooltip.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./LabelWithTooltip.styles.ts");